module.exports = "<div class=\"form-control-static\" ng-bind=\"firstCharData.value | number\"></div>"